/**
 * botanicalscent.eu — predictive search
 * Debounced fetch against Shopify's predictive search endpoint.
 */
(function () {
  "use strict";

  var input = document.querySelector("[data-predictive-search-input]");
  var results = document.querySelector("[data-predictive-search-results]");
  if (!input || !results) return;

  var timer = null;

  function money(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "EUR"
    });
  }

  function render(products) {
    if (!products.length) {
      results.innerHTML = "";
      return;
    }
    results.innerHTML = products.map(function (p) {
      return (
        '<a class="search-modal__result" href="' + p.url + '">' +
        '<img src="' + (p.image || "") + '" alt="' + p.title + '" loading="lazy">' +
        '<span><span class="search-modal__result-title">' + p.title + '</span><br>' +
        '<span class="search-modal__result-price">' + money(p.price) + "</span></span>" +
        "</a>"
      );
    }).join("");
  }

  input.addEventListener("input", function () {
    var term = input.value.trim();
    window.clearTimeout(timer);
    if (term.length < 2) {
      results.innerHTML = "";
      return;
    }
    timer = window.setTimeout(function () {
      fetch("/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=6")
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products);
        })
        .catch(function () {});
    }, 250);
  });
})();
